import {useState} from 'react';
import {useNavigate} from 'react-router';
import {logoutHelper} from '../utils';
import {unregisterFcmTokenOnLogout} from '../utils/fcmToken';
import {handleUpsertOnBoardingDraftService} from '../services/on-boarding';
import {buildOnBoardingDraftPayload} from '../pages/on-boarding/buildOnBoardingDraftPayload';
import {networkDetailsSchema} from '../pages/on-boarding/components/NetworkDetails/networkDetailsSchema';
import {
  getPersistedDraftData,
  clearPersistedDraftData,
} from '../pages/on-boarding/components/NetworkDetails/NetworkDetailsDraftContext';

export function useOnBoardingLogout() {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      const savedData = await getPersistedDraftData();
      if (savedData) {
        const transformed = await buildOnBoardingDraftPayload(
          savedData.network,
        );
        await handleUpsertOnBoardingDraftService({
          data: transformed,
          isValidData: networkDetailsSchema.safeParse(savedData).success,
        });
        await clearPersistedDraftData();
      }
    } catch (error) {
      console.error('Failed to save on-boarding draft before logout:', error);
    } finally {
      await unregisterFcmTokenOnLogout();
      logoutHelper();
      navigate('/');
    }
  };

  return {handleLogout, isLoggingOut};
}
